import { CountryData, IStatisticsJSON, LevelsList } from "~/types/statistics";

const DEFAULT_STATISTICS: CountryData = {
  statistics: {
    facility_amount: 0,
    activity_amount: 0,
  },
  levels: {},
  archived_levels: {},
};

const changeLevelOrder = (countryData: CountryData): CountryData => {
  const { levels, statistics, archived_levels } = countryData;

  const orderedLevels: LevelsList = {
    ...(levels.vip && { vip: levels.vip }),
    ...(levels.platinum && { platinum: levels.platinum }),
    ...(levels.gold && { gold: levels.gold }),
    ...(levels.silver && { silver: levels.silver }),
    ...(levels.region && { region: levels.region }),
  };

  return {
    levels: orderedLevels,
    statistics,
    archived_levels,
  };
};

export async function getStatistics(countryCode: string): Promise<CountryData> {
  const res = await import("public/json/statistics.json").then(
    (m) => m.default || m
  );

  const statistics = res as unknown as IStatisticsJSON;

  return (
    changeLevelOrder(statistics[countryCode]) ?? {
      facility_amount: undefined,
      activity_amount: undefined,
    }
  );
}
